import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { Tooltip } from '../elements-tooltip/tooltip';

const LineItem = ({ label, value, optionalValue, currencyType, customClass = '' }) => {
  return (
    <tr className={`line-item ${customClass} ${optionalValue ? 'long-row' : 'short-row'}`}>
      <td className={`row-label ${label.optionalClass || ''} table-data`}>
        {label.content}
        {label.optionalTooltip &&
            <span className="tooltip-style-left">
              <Tooltip tooltip={label.optionalTooltip} />
            </span>
        }
      </td>
      {
        value &&
        <td className={`${optionalValue ? 'middle-data' : 'right-data'} table-data ${value.optionalClass || ''}`}>
          {value.optionalTooltip &&
            <span className="tooltip-style-right">
              <Tooltip tooltip={value.optionalTooltip} />
            </span>
          }
          {
            value.customValue
              ? value.customValue
              : value.amount && <FormattedNumber value={value.amount} currency={currencyType} style={'currency'} />
          }
        </td>
      }
      {
        optionalValue &&
        <td className={`${optionalValue.optionalClass || ''} table-data right-data`}>
          {optionalValue.optionalTooltip &&
            <span className="tooltip-style-right">
              <Tooltip tooltip={optionalValue.optionalTooltip} />
            </span>}
          {
            optionalValue.customValue
              ? optionalValue.customValue
              : optionalValue.amount && <FormattedNumber value={optionalValue.amount} currency={currencyType} style={'currency'} />
          }
        </td>
      }
    </tr>
  );
};

export { LineItem };

LineItem.propTypes = {
  label: PropTypes.shape({
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    optionalTooltip: PropTypes.object
  }).isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    optionalClass: PropTypes.string,
    optionalTooltip: PropTypes.object
  }),
  optionalValue: PropTypes.shape({
    amount: PropTypes.number,
    optionalClass: PropTypes.string,
    optionalTooltip: PropTypes.object
  }),
  currencyType: PropTypes.string.isRequired,
  customClass: PropTypes.string
};
